export const FPR_DATA_STORAGE_KEY = "subscriptionDetails";

export const CPR_ENTRY_POINT = "cprEntryPoint";

export const CPR_FORM_DATA_KEY = "cfdk";

export const CP_COOKIE_CONSTANTS = {
  cScore: "cScore",
  fsup: "fsup",
  cpss: "cpss",
  redirectionUrl: "redirectionUrl",
  planCode: "planCode",
  cpsd: "cpsd",
  default: "default",
  true: "true",
  ucnav: "ucnav",
  cp: "cp",
} as const;
